import type { Command } from 'commander';
import { loadCredentials, maskKey, resolveApiKey } from '../../lib/credentials-store';

interface WhoamiGlobals {
	apiKey?: string;
}

export function registerEnterpriseWhoami(parent: Command): void {
	parent
		.command('whoami')
		.description('Show which enterprise key is in effect (offline; reads local state only)')
		.action((_flags: unknown, command: Command) => {
			const globals = command.optsWithGlobals() as WhoamiGlobals;
			const resolved = resolveApiKey(globals.apiKey);
			const creds = resolved.source === 'file' ? loadCredentials() : null;
			const lines = [
				`key:     ${maskKey(resolved.key)}`,
				`source:  ${resolved.source}`,
				`company: ${creds?.company_name || '(unknown)'}`,
			];
			if (creds?.saved_at) lines.push(`saved:   ${creds.saved_at}`);
			process.stdout.write(lines.join('\n') + '\n');
		});
}
